//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams, countDownTimeFunc, toCopy } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import { Dialog, Toast } from "vant";

export default {
  name: "Purchase",
  components: {
    footerNav
  },
  data() {
    return {
      searchValue: "",
      loading: false,
      finished: false,
      refreshing: false,
      purchaseList: [],
      toCopy
    };
  },
  created() {},
  mounted() {},
  updated() {
    document.scrollingElement.scrollTop = 0;
  },
  methods: {
    goPurchase(purchaseOrderId) {
      this.$router.push({
        name: "procurementClearance",
        query: { purchaseOrderId: purchaseOrderId, type: "view" }
      });
    },
    onSearch() {
      this.purchaseList = [];
      this.onLoad();
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        searchValueList:
        this.searchValue == "" ? [] : this.searchValue.split(" "),
        // "qualityOrderType": 1,
        start: 0,
        size: 10,
        orderRules: [{ orderKey: "purchaseOrderId", desc: true }],
        desc: true
      };
      axiosApi.queryPurchaseList(params).then(response => {
        if (
          response.content &&
          response.content.list &&
          response.content.list.length > 0
        ) {
          response.content.list.forEach(item => {
            var channelStr = "";
            if (item.firstDeptName) {
              channelStr += item.firstDeptName;
            }
            if (item.secondDeptName) {
              channelStr += "/" + item.secondDeptName;
            }
            item.channelStr = channelStr;
            if (item.isStockIn == 1) {
              item.isStockInStr = "是";
            }
            if (item.isStockIn == 0) {
              item.isStockInStr = "否";
            }
            if (item.isRedone == 1) {
              item.isRedoneStr = "是";
            }
            if (item.isRedone == 0) {
              item.isRedoneStr = "否";
            }
          });
          this.purchaseList = this.purchaseList.concat(response.content.list);
        }
        this.loading = false;
        this.refreshing = false;
        if (this.purchaseList.length == response.content.total) {
          this.finished = true;
        }
      });
    },
    toDetail() {
      this.$router.push({ name: "purchaseDetail" });
    },
    toContract(item) {
      this.$router.push({
        name: "contractDetail",
        query: { purchaseOrderId: item.purchaseOrderId }
      });
    },
    addSend() {
      this.$router.push({ name: "sendOrderAdd" });
    },
    createSend(item) {
      this.$router.push({
        name: "createSendOrder",
        query: { data: JSON.stringify([item]) }
      });
    },
    toProcess(item) {
      this.$router.push({
        name: "qualityProcess",
        query: { purchaseOrderId: item.purchaseOrderId, spuCode: item.spuCode }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/purchase/index.vue